import { ResourceContextProvider } from "ra-core";
import { matchPath, useLocation } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";

import SponsoringList from "./SponsoringList";
import { SponsoringListMobile } from "./SponsoringListMobile";
import { SponsoringShowMobile } from "./SponsoringShowMobile";
import { sponsoringViewBasePath, type SponsoringView } from "./sponsoringViews";

/**
 * The page behind the /balsponsoren and /leads routes. Those are custom
 * routes (the sponsorings resource keeps /sponsorings), so this component
 * does what <Resource> does for the resource route: pick the desktop or the
 * mobile list, and — on mobile, where the show view is a page and not a
 * dialog — render the show page on `${basePath}/:id/show`.
 */
export const SponsoringViewPage = ({ view }: { view: SponsoringView }) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const basePath = sponsoringViewBasePath[view];
  const matchShow = matchPath(`${basePath}/:id/show`, location.pathname);

  return (
    <ResourceContextProvider value="sponsorings">
      {!isMobile ? (
        <SponsoringList view={view} />
      ) : matchShow ? (
        <SponsoringShowMobile id={matchShow.params.id} basePath={basePath} />
      ) : (
        <SponsoringListMobile view={view} />
      )}
    </ResourceContextProvider>
  );
};
